// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { Volume } from './Volume';
import { VolumePrism } from './VolumePrism';
import { PrismRange } from './PrismRange';
import { Polygon2D } from './Polygon2D';
import { Coordinate } from './Coordinate';

export class Airspace implements IAirspace {
    id!: string;
    volumes!: Volume[];

    constructor(data?: IAirspace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["volumes"])) {
                this.volumes = [] as any;
                for (let item of _data["volumes"])
                    this.volumes!.push(Volume.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Airspace {
        data = typeof data === 'object' ? data : {};
        let result = new Airspace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.volumes)) {
            data["volumes"] = [];
            for (let item of this.volumes)
                data["volumes"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAirspace {
    id: string;
    volumes: Volume[];
}